import moment from 'moment/moment';
import { dayOfMonth } from 'Consts/DateFormats';

export function getDynamicDateTypeValue(resource, type, dateFormat = dayOfMonth) {
  if (type !== 'start' && type !== 'end') {
    throw new Error('Invalid type given to getDynamicDateValue. Must be "start" or "end"');
  }

  const dateType = resource.attr(`${type}Type`);
  const dateTypeMetaOptions = resource.metaField(`${type}Type`).options().list();
  const prompt = dateTypeMetaOptions.find(m => m.attr('id') === dateType)?.attr('prompt');

  if (dateType.includes('age')) {
    return {
      key: `${type}Type`,
      value: `${prompt}: ${resource.attr(`${type}AtAge`)}`,
    };
  }

  if (dateType.includes('retirement') || dateType.includes(`${type}OfScenario`)) {
    return {
      key: `${type}Type`,
      value: prompt,
    };
  }

  return {
    key: `${type}Date`,
    value: moment.utc(resource.attr(`${type}Date`)).format(dateFormat),
  };
}
